import { createSlice } from '@reduxjs/toolkit';
import { getAllReportByStudyInstanceApi } from '../../../rtk-apis/reports/getAllReportByStudyInstance';

const initialState = {
  status: '',
  data: [],
  msg: '',
  loading: false,
};

const getAllReportByStudyInstanceSlice = createSlice({
  name: 'getAllReportByStudyInstanceSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = [];
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAllReportByStudyInstanceApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllReportByStudyInstanceApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(getAllReportByStudyInstanceApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = [];
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getAllReportByStudyInstanceSlice.reducer;
export const { clearState } = getAllReportByStudyInstanceSlice.actions;
